// @ts-nocheck -- verbatim TAPP payroll UI compatibility boundary
import { clsx } from "clsx";
import { Avatar as HeroAvatar } from "@heroui/react";

type AvatarSize = "xs" | "sm" | "md" | "lg" | "xl";

const sizeClasses: Record<AvatarSize, string> = {
  xs: "size-6 text-[10px]",
  sm: "size-8 text-xs",
  md: "size-10 text-sm",
  lg: "size-12 text-base",
  xl: "size-16 text-xl",
};

interface AvatarProps {
  src?: string;
  initials?: string;
  alt?: string;
  size?: AvatarSize;
  className?: string;
  online?: boolean;
}

export function Avatar({
  src,
  initials = "?",
  alt = "",
  size = "md",
  className,
  online,
}: AvatarProps) {
  return (
    <div className={clsx("relative shrink-0 inline-flex", className)}>
      <HeroAvatar.Root
        size={size === "xs" ? "sm" : size === "xl" ? "lg" : size}
        variant="soft"
        color="accent"
        className={clsx(
          "rounded-full overflow-hidden flex items-center justify-center font-semibold",
          "border border-border-strong bg-surface text-foreground select-none",
          sizeClasses[size],
        )}
      >
        {src ? (
          <HeroAvatar.Image src={src} alt={alt} className="size-full object-cover" />
        ) : (
          <HeroAvatar.Fallback>{initials.slice(0, 2).toUpperCase()}</HeroAvatar.Fallback>
        )}
      </HeroAvatar.Root>
      {online !== undefined && (
        <span
          className={clsx(
            "absolute bottom-0 right-0 block rounded-full border-2 border-surface",
            size === "xs" || size === "sm" ? "size-2" : "size-2.5",
            online ? "bg-success" : "bg-foreground-subtle",
          )}
          aria-label={online ? "Online" : "Offline"}
        />
      )}
    </div>
  );
}
